import { render, staticRenderFns } from "./sticky-banner.vue?vue&type=template&id=05ddbc38&"
import script from "./sticky-banner.vue?vue&type=script&lang=js&"
export * from "./sticky-banner.vue?vue&type=script&lang=js&"
import style0 from "./sticky-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports